import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function NewsPage() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/news").then((r) => setItems(r.data));
  }, []);

  return (
    <div data-testid="news-page">
      <section className="bg-slate-900 text-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="overline text-amber-400 mb-3">Newsroom</div>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black tracking-tight max-w-3xl leading-tight">
            Updates from the field & the floor.
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((n) => (
            <Link
              key={n.id}
              to={`/news/${n.id}`}
              data-testid={`news-card-${n.id}`}
              className="group block border border-slate-200 hover:border-amber-500 transition-colors"
            >
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                <img src={n.image_url} alt={n.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              </div>
              <div className="p-5">
                <div className="font-mono text-xs text-slate-500 mb-2 flex items-center gap-2">
                  <Calendar className="w-3 h-3" />
                  {new Date(n.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                </div>
                <h3 className="font-heading font-bold text-lg text-slate-900 group-hover:text-amber-600 line-clamp-2">
                  {n.title}
                </h3>
                <p className="text-sm text-slate-600 mt-2 line-clamp-3">{n.summary}</p>
                <div className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-amber-600">
                  Read more <ArrowRight className="w-3 h-3" />
                </div>
              </div>
            </Link>
          ))}
        </div>
        {items.length === 0 && (
          <div className="text-center py-20 text-slate-500">No news yet.</div>
        )}
      </section>
    </div>
  );
}
